<template>
    <div class="row">
        <div v-for="coupon in all_coupons" class="col-12 col-lg-6 mb-4">
            <coupon :url-use-coupon="urlUseCoupon" :preset-coupon="coupon" :is-vivaincontri="isVivaincontri"></coupon>
        </div>
    </div>
</template>
<script>
import Coupon from "./coupon"
export default {
    name: "CouponsList",
    props: {
        coupons: {
            required: false,
            default() {
                return []
            }
        },
        urlUseCoupon:{
          required:true,
          type: String
        },
        isVivaincontri: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            all_coupons:[]
        };
    },
    components:{
        Coupon
    },
    methods:{
        addCoupon(coupon){
            this.all_coupons.push(coupon)
        },
        numCoupons(type){
            if(type)
                return this.all_coupons.filter(function(coupon){
                  return coupon.valid_for==type;
                }).length;
            else
                return this.all_coupons.length
        }
    },
    mounted() {
        if(this.coupons)
            this.all_coupons = this.coupons
        this.$store.dispatch("coupons/setCouponsList", this).then()
    }
}
</script>

